import Vue from 'vue'
import Vuex from 'vuex'
import {WGKSERVICE,dataLayer} from '../http-common';
import router from "../router";
import {vm} from "../main";
import VuexReset from '@ianwalter/vuex-reset'
Vue.use(Vuex)

const sortObjKeysAlphabetically = (obj) => Object.fromEntries(Object.entries(obj).sort());

export const store =  new Vuex.Store({
  plugins: [VuexReset()],
  state: {
    lang: 'de',
    loadingStatus: false,
    debug: false,
    elbridge_hook_url: '',
    desktopOptimizedConfig: true,
    desktopOptimizedSwitch: false,
    errors: [],
    userRoles: [],
    initialQueryParams: {},
    wgkCurrentStep: 1,
    wgkSuperGroups: {},
    wgkGroups: {},
    //wgkStepsSchema: {},
    wgkStepsSchema1: [],
    wgkStepsSchema2: [],
    wgkStepsSchema3: [],
    wgkStepsSchema4: [],
    wgkStepsValues: {
      "W_GROUP_0001": [],
      "W_GROUP_0002": [],
      "W_GROUP_0003": [],
      "W_GROUP_0004": [],
    },
    wgkStepsValuesOld: {},
    wgkServiceFilterBeforeChange: '',
    wgkServiceFilter: '',
    wgkStepsLoadingStatus: {
      "W_GROUP_0001": false,
      "W_GROUP_0002": false,
      "W_GROUP_0003": false,
      "W_GROUP_0004": false,
    },
    wgkStepResultLoading: false,
    wgkStepsValid: {
      "W_GROUP_0001": {
        hasData: false,
        valid: true,
        msg: ''
      },
      "W_GROUP_0002": {
        hasData: false,
        valid: true,
        msg: ''
      },
      "W_GROUP_0003": {
        hasData: false,
        valid: true,
        msg: ''
      },
      "W_GROUP_0004": {
        hasData: false,
        valid: true,
        msg: ''
      },
    },
    wgkResultProducts: {}
  },
  getters: {
    wgkCurrentStep: state => state.wgkCurrentStep,
    wgkSuperGroups: state => state.wgkSuperGroups,
    wgkGroups: state => state.wgkGroups,
    wgkStepsSchema: state => state.wgkStepsSchema,
    wgkStepsValues: state => state.wgkStepsValues,
    wgkResultProducts: state => state.wgkResultProducts,
    errors: state => state.errors,
    debug: state => state.debug,
    elbridgeHookURL: state => state.elbridge_hook_url
  },
  mutations: {
    reset: () => {},
    SET_LANG(state,lang) {
      state.lang = lang
    },
    SET_LOADING_STATUS(state, status) {
      state.loadingStatus = status
    },
    SET_ERROR(state, error) {
      state.errors.push(error)
    },
    SET_USER_ROLES(state,payload) {
      state.userRoles = payload
    },
    SET_DEBUG(state,value) {
      if (value === 'true') {
        state.debug = true;
      } else {
        state.debug = false;
      }
    },
    SET_ELBRIDGE_HOOK_URL(state,value) {
      state.elbridge_hook_url = value
    },
    SET_DESKTOP_OPTIMIZED_SWITCH(state,value) {
      state.desktopOptimizedSwitch = value;
    },
    SET_INITIAL_QUERY_PARAMS(state,query) {
      state.initialQueryParams = query
    },
    SET_WGK_CURRENT_STEP(state, pos) {
      state.wgkCurrentStep = parseInt(pos)
    },
    SET_WGK_SUPER_GROUPS(state, data) {
      state.wgkSuperGroups = data
    },
    SET_WGK_GROUPS(state, data) {
      Object.assign (state.wgkGroups, {[data.id]: data})
    },
    SET_WGK_STEPS_SCHEMA(state, schema) {
      //state.wgkStepsSchema = Object.assign({}, state.wgkStepsSchema, schema);
      //Object.assign (state.wgkStepsSchema, schema)
      state.wgkStepsSchema1 = [schema['W_GROUP_0001']];
      state.wgkStepsSchema2 = [schema['W_GROUP_0002']];
      state.wgkStepsSchema3 = [schema['W_GROUP_0003']];
      state.wgkStepsSchema4 = [schema['W_GROUP_0004']];
    },
    SET_WGK_RESULT_PRODUCTS(state, data) {
      //state.wgkResultProducts = Object.assign({}, state.wgkResultProducts, data);
      state.wgkResultProducts = data;
    },
    SET_WGK_STEPS_VALUES_INITIAL(state, data) {
      state.wgkStepsValuesInitial = data;
    },
    ASSIGN_WGK_STEPS_VALUES(state, data) {
      state.wgkStepsValues = Object.assign({}, state.wgkStepsValues, data);
    },
    SET_WGK_STEPS_VALUES_OLD(state, data) {
      state.wgkStepsValuesOld = data;
    },
    SET_WGK_SERVICE_FILTER(state, value) {
      state.wgkServiceFilter = value;
    },
    SET_WGK_SERVICE_FILTER_BEFORE_CHANGE(state,value) {
      state.wgkServiceFilterBeforeChange = value;
    },
    SET_WGK_STEPS_LOADING_STATUS(state,payload) {
      state.wgkStepsLoadingStatus[payload.group] = payload.value;
    },
    SET_WGK_STEPS_VALID_STATUS(state,payload) {
      state.wgkStepsValid[payload.group].valid = payload.valid;
      state.wgkStepsValid[payload.group].msg = payload.msg;
    },
    SET_WGK_STEPS_VALID_HAS_DATA(state,payload) {
      state.wgkStepsValid[payload.group].hasData = payload.hasData;
    },
    SET_WGK_STEP_RESULT_LOADING(state,value) {
      state.wgkStepResultLoading = value;
    }
  },
  actions: {

    updateDesktopOptimizedSwitch(context, isMobile) {
      if (context.state.desktopOptimizedConfig && !isMobile) {
        context.commit('SET_DESKTOP_OPTIMIZED_SWITCH', true);
      } else {
        context.commit('SET_DESKTOP_OPTIMIZED_SWITCH', false);
      }
    },

    fetchAndSetWgkSuperGroups(context) {
      context.commit('SET_LOADING_STATUS',true)
      WGKSERVICE.get( this.state.lang )
      .then(response => {
        context.commit('SET_WGK_SUPER_GROUPS', response.data['superGroups'])
        context.dispatch('fetchAndSetWgkGroups').then(() => {
          context.dispatch('updateStepsSchema').then(() => {
            context.commit('SET_LOADING_STATUS', false)
          })

        })
      })
      .catch(e => {
        context.commit('SET_ERROR', e)
      })
    },

    fetchAndSetWgkGroups(context, range = 'all') {

      return new Promise((resolve) => {

      let store = this;
      let superGroups = store.state.wgkSuperGroups;
      let promisedEvents = [];
      let i = 1;

      superGroups.forEach(function(item){

        if (Object.prototype.hasOwnProperty.call(item, "id") && item.id.length ) {
          //promisedEvents.push(WGKSERVICE.get( store.state.lang + '/' + item.id ));
          if (range === 'all' || (range !== 'all' && i >= range )) {
            promisedEvents.push(WGKSERVICE.get( store.state.lang + '/' + item.id + '?filter=' + store.state.wgkServiceFilter + '&debug=' + store.state.debug));
            context.commit('SET_WGK_STEPS_LOADING_STATUS', {
              group: item.id,
              value: true
            })
          }
          i++;
        }

      });

      Promise.all(promisedEvents)
        .then(async function (results) {
          results.forEach(function(item){
            context.commit('SET_WGK_GROUPS', item.data)
            context.commit('SET_WGK_STEPS_LOADING_STATUS', {
              group: item.data.id,
              value: false
            })
          });
          resolve()
        });

      })
    },

    fetchAndSetWgkResultProducts(context) {
      return new Promise((resolve, reject) => {
        context.commit('SET_WGK_STEP_RESULT_LOADING',true)
        WGKSERVICE.get( this.state.lang + '/products/?filter=' + context.state.wgkServiceFilter )
          .then(response => {
            context.commit('SET_WGK_RESULT_PRODUCTS', response.data)
            context.commit('SET_WGK_STEP_RESULT_LOADING',false)
            resolve()
          })
          .catch(e => {
            context.commit('SET_ERROR', e)
            reject()
          })
      })
    },

    updateStepsSchema(context) {

      let schema = [];

      for (const [index, data] of Object.entries(context.getters.wgkGroups)) {

        schema[index] = {
          name: data.id,
          type: 'group',
        }

        let children = [];

        if(Object.prototype.hasOwnProperty.call(data, "filterSelections")) {

          data['filterSelections'].forEach((element, index) => {
            //console.log(index);

            let child = {};
            let optionsType = 'checkbox';

            switch (element.selectionType) {
              case 'SINGLE':
                optionsType = 'RadioButton';
                break;
              case 'MULTI_OR':
              case 'MULTI_AND':
                optionsType = 'Checkbox';
                break;
            }

            child.label = element.text.trim();
            child.name = element.featureCode;
            child.type = optionsType;

            if (Object.prototype.hasOwnProperty.call(element, "imageUrl") && element.imageUrl.length ) {
              child.imageUrl = element.imageUrl;
            }

            let options = {}
            element.options.forEach((option) => {
              options[option.id] = option.text;
            });
            child.options = options;

            // for checkboxes build groups by category for later ui only grouping
            if (child.type === 'Checkbox') {
              let optionGroups = vm.groupBy(element.options,'category');
              child.optionGroups = {}

              Object.entries(optionGroups).forEach(([key, options]) => {
                let subOptions = {};
                options.forEach((option) => {
                  subOptions[option.id] = option.text;
                });
                child.optionGroups[key] = subOptions;
              });

            }

            children[index] = child;

          });
          schema[index]['children'] = children;

        } else {
          schema[index]['children'] = [];
        }

      }

      context.commit('SET_WGK_STEPS_SCHEMA', schema)

    },

    updateWgkStepsValues(context, value) {
      context.commit('ASSIGN_WGK_STEPS_VALUES', value);
    },

    forceSchemaUpdate(context, currentStep) {

      if(store.state.wgkServiceFilter.length > 0 && !store.state.loadingStatus) {
        context.dispatch('cleanAllValuesAfterStep', currentStep).then(() => {
          context.dispatch('fetchAndSetWgkGroups', currentStep).then(() => {
            context.dispatch('updateStepsSchema').then(() => {
              context.dispatch('getValuesBackAfterStep', currentStep).then(() => {
                // be sure to update Schema again based on back values
                context.dispatch('fetchAndSetWgkGroups', currentStep + 1).then(() => {
                  context.dispatch('updateStepsSchema');
                });

              });
            });
          });
        });
      }

    },

    convertWgkStepsValuesToURLParams(context) {
      let params = {}
      for (let prop in context.getters.wgkStepsValues) {

        let steps = context.getters.wgkStepsValues[prop];
        //console.log(JSON.stringify(steps));
        let values = "";

        steps.forEach(function(item){
          let i = 0;
          for (let prop in item) {
            if(item[prop].length > 0) {
              if (i === 0) {
                values += prop + '-' + item[prop];
              } else {
                values += '.' + prop + '-' + item[prop];
              }
            }
            i++;
          }
        });

        params[prop] = values;
        params['Step'] = context.getters.wgkCurrentStep;
        if (context.getters.debug) {
          params['Debug'] = context.getters.debug;
        }
        //console.log (context.getters.wgkStepsValues[prop][0]);
      }
      return sortObjKeysAlphabetically(params);
    },
    convertURLParamsToWgkStepsValues(context,initial = false) {
      let query = context.state.route.query;

      if(initial) {
        query = context.state.initialQueryParams;
      }

      // set current step if in url
      if(Object.prototype.hasOwnProperty.call(query, "Step")){
        context.commit('SET_WGK_CURRENT_STEP',query.Step);
      }

      // set debug modus if in url
      if(Object.prototype.hasOwnProperty.call(query, "Debug")){
        context.commit('SET_DEBUG',query.Debug);
      }

      let queryParams = {};

      for (let propertyName in query) {

        if (propertyName.indexOf("W_GROUP") === 0) {
          queryParams[String(propertyName)] = [];
          let param = query[String(propertyName)];
          let objectProAndValues = {}
          //console.log(queryParams);
          if(param.length > 0) {
            let items = param.split(".");
            items.forEach(function(item){
              let itemSplitted = item.split(/-(.+)/);
              let value = itemSplitted[1];
              // for checkboxes we must build an array
              if (itemSplitted[1].includes(",")) {
                value = itemSplitted[1].split(",");
              }
              let temp = {
                [itemSplitted[0]]: value
              }

              Object.assign (objectProAndValues, temp);
            });
            //console.log (objectProAndValues);
            queryParams[propertyName].push(objectProAndValues);
          }
        }

      }
      //console.log(queryParams);
      return queryParams;

    },

    updateWGKServiceFilter(context) {

      let data = context.state.wgkStepsValues;
      let filter = '';

      // iterate over steps values and build filter for WGK Service
      for (let step in data) {
        if (data[step].length > 0) {
          //console.log(data[step]);
          data[step].forEach(function(group){
            if(vm.notEmptyObject(group)) {
              for (let item in group) {
                if (Array.isArray(group[item])) {
                  // array = checkboxes = e.g. // WG_AGROUP0002-FEATURE_0002
                  group[item].forEach(function(checkbox) {
                    filter += item + '-' + checkbox + ',';
                  });
                } else {
                  // string = radio = e.g. WG_AGROUP0001A-FEATURE_0002
                  filter += item + '-' + group[item] + ',';
                }
              }
            }
          });
        }
      }

      if (filter.length > 0 ) {
        filter = filter.slice(0, -1);
      }

      //console.log(filter);
      context.commit('SET_WGK_SERVICE_FILTER',filter);


      // ?filter=
      // WG_AGROUP0001A-FEATURE_0002,
      // WG_AGROUP0001B-FEATURE_0003,
      // WG_AGROUP0002-FEATURE_0002--FEATURE_0003--FEATURE_0018,
      // WG_AGROUP0002-FEATURE_0002--FEATURE_0003--FEATURE_0015,
      // WG_AGROUP0003-FEATURE_0002--FEATURE_0003--FEATURE_0015--FEATURE_0032,
      // WG_AGROUP0003-FEATURE_0002--FEATURE_0003--FEATURE_0015--FEATURE_0034,
      // WG_AGROUP0004-FEATURE_0002--FEATURE_0003--FEATURE_0015--FEATURE_0032--FEATURE_0052,
      // WG_AGROUP0004-FEATURE_0002--FEATURE_0003--FEATURE_0015--FEATURE_0034--FEATURE_0054


      // ?Step=4&
      // W_GROUP_0001=WG_AGROUP0001A-FEATURE_0002.WG_AGROUP0001B-FEATURE_0003
      // &W_GROUP_0002=WG_AGROUP0002-FEATURE_0014,FEATURE_0016
      // &W_GROUP_0003=WG_AGROUP0003-FEATURE_0033,FEATURE_0030
      // &W_GROUP_0004=WG_AGROUP0004-FEATURE_0002,FEATURE_0052,FEATURE_0046

    },

    cleanAllValuesAfterStep(context, cStep) {

      // save back current values first
      context.commit('SET_WGK_STEPS_VALUES_OLD',context.state.wgkStepsValues);

      //console.log ('clean all after:' + cStep)

      let i = parseInt(cStep) + 1;
      let cStepValues = Object.keys(context.state.wgkStepsValues).length;

      //console.log(i);



      if (i !== cStepValues + 1) {
        for (i; i <= cStepValues; i++) {
          if(Object.prototype.hasOwnProperty.call(context.state.wgkStepsValues, "W_GROUP_000" + i)){
            let resetObject = {};
            resetObject['W_GROUP_000' +i] = [];
            //console.log(JSON.stringify(resetObject));
            context.commit('ASSIGN_WGK_STEPS_VALUES',resetObject);
          }

        }
      }

    },

    getValuesBackAfterStep(context, cStep) {



      let i = parseInt(cStep) + 1;
      let cStepValues = Object.keys(context.state.wgkStepsValuesOld).length;

      //console.log ('get values back after:' + i);

      if (i !== cStepValues + 1) {
        for (i; i <= cStepValues; i++) {
          if(Object.prototype.hasOwnProperty.call(context.state.wgkStepsValuesOld, "W_GROUP_000" + i)){

            let currentSchema = [];
            switch (i) {
              case 1:
                currentSchema =  context.state.wgkStepsSchema1
                break;
              case 2:
                currentSchema =  context.state.wgkStepsSchema2
                break;
              case 3:
                currentSchema =  context.state.wgkStepsSchema3
                break;
              case 4:
                currentSchema =  context.state.wgkStepsSchema4
                break;
            }

            let currentValues = context.state.wgkStepsValuesOld['W_GROUP_000' + i];

            // build schemaArray for value comparison

            let schemaArray = [];

            if (currentSchema[0].children.length > 0) {
              currentSchema[0].children.forEach(function(item){
                schemaArray = schemaArray.concat(Object.keys(item.options));
              });
            }

            // clone object
            let newValues = currentValues;

            // compare and strip
            currentValues.forEach(function(item,indexParent){
              for (let prop in item) {
                let test = JSON.parse((JSON.stringify(item[prop])));
                //console.log (test);
                // Array vs single option !!!!
                if (Array.isArray(test)) {
                  test.forEach(function(itemToCheck){
                    //console.log (itemToCheck);
                    // if not found in schema
                    if (schemaArray.indexOf(itemToCheck) === -1) {
                      const findIndex = newValues[indexParent][prop].indexOf(itemToCheck);
                      if (findIndex > -1) {
                        newValues[indexParent][prop].splice(findIndex, 1);
                      }
                    }
                  });
                } else { // single checkbox case
                  if (schemaArray.indexOf(test) === -1) {
                    newValues[indexParent][prop] = '';
                  }
                }

              }
              //console.log(indexParent);
            });

            //console.log (JSON.stringify(currentValues));
            //console.log (JSON.stringify(newValues));


            let resetObject = {};
            resetObject['W_GROUP_000' +i] = newValues;

            //console.log(JSON.stringify(schemaArray));
            //console.log(JSON.stringify(resetObject));

            context.commit('ASSIGN_WGK_STEPS_VALUES',resetObject);
            // todo: maybe instead of cleaning all substep values we could only remove properties which are not in the affected step schema ?
          }

        }
      }

    },

    setInitialData(context) {
      context.dispatch('fetchAndSetWgkSuperGroups').then(() => {
        if(vm.notEmptyObject(context.state.initialQueryParams)) {
          context.dispatch('convertURLParamsToWgkStepsValues',true).then((valuesFromUrl) => {
            if (vm.notEmptyObject(valuesFromUrl))
            {
              context.commit('ASSIGN_WGK_STEPS_VALUES',valuesFromUrl);
            }
          })
        }
      })
    },

    resetStore(context) {
      context.commit('reset');
    },

    updateWgkStepsHasData(context,payload) {

      let hasData = false;

      if(payload.schema.length > 0) {
        if (typeof (payload.schema[0].children !== 'undefined') && payload.schema[0].children.length > 0) {
          hasData = true;
        }
      }

      store.commit('SET_WGK_STEPS_VALID_HAS_DATA', {
        group: payload.group,
        hasData: hasData
      })

    },

    trackStep(context) {
      dataLayer.push({
        'event': 'clickEvent',
        'eventCategory': 'DEHNselect Wohngebaeude',
        'eventAction': 'Schritt ' + context.state.wgkCurrentStep,
        'eventLabel': context.state.route.fullPath,
      });
    },
    trackCustomAction(context,action) {
      dataLayer.push({
        'event': 'clickEvent',
        'eventCategory': 'DEHNselect Wohngebaeude',
        'eventAction': action,
        'eventLabel': context.state.route.fullPath,
      });
    },

  },
})

store.watch((state) => state.wgkStepsValues, () => {

      store.dispatch('convertWgkStepsValuesToURLParams').then((params) => {
        router.replace({
          query: params
        }).catch(err => {
          if (err.name !== "NavigationDuplicated") {
            throw err;
          }
        })
      })

    store.dispatch('updateWGKServiceFilter');

  },
  {
    deep:true
  }
)


store.watch((state) => state.wgkStepsSchema1, (schema) => {
  store.dispatch({
    type: 'updateWgkStepsHasData',
    schema: schema,
    group: 'W_GROUP_0001',
  })
})

store.watch((state) => state.wgkStepsSchema2, (schema) => {
  store.dispatch({
    type: 'updateWgkStepsHasData',
    schema: schema,
    group: 'W_GROUP_0002',
  })
})

store.watch((state) => state.wgkStepsSchema3, (schema) => {
  store.dispatch({
    type: 'updateWgkStepsHasData',
    schema: schema,
    group: 'W_GROUP_0003',
  })
})


store.watch((state) => state.wgkStepsSchema4, (schema) => {
  store.dispatch({
    type: 'updateWgkStepsHasData',
    schema: schema,
    group: 'W_GROUP_0004',
  })
})


store.watch((state) => state.wgkCurrentStep, (to, from) => {

  router.push({
    query: Object.assign({}, store.state.route.query, {Step: store.state.wgkCurrentStep})
  }).catch(err => {
    if (err.name !== "NavigationDuplicated") {
      throw err;
    }
  })

  store.dispatch('trackStep');

  if ( store.state.wgkServiceFilter !== store.state.wgkServiceFilterBeforeChange)
  {
    // save back service filter status
    store.commit('SET_WGK_SERVICE_FILTER_BEFORE_CHANGE', store.state.wgkServiceFilter);

    //console.log('from: ' + from + 'to: ' + to);

    // for default upward steps
    if(!store.state.desktopOptimizedSwitch) {
      if (to > from) {
        //console.log('step change schmea DEFAULT update from: ' + from )
        store.dispatch('forceSchemaUpdate', from);

      }
    // for desktop version
    } else {
      if (from === 1) {
        //console.log ('von Desktop schritt1:' + from)
        store.dispatch('forceSchemaUpdate', from);

      }
      if (from !== 1 && to !== 1) {
        //console.log('step change schmea DESKTOP update to: ' + to )
        store.dispatch('forceSchemaUpdate', to);

      }
    }



  }


  }
)
